import { get } from "../GenericServices";

const Resource = {
  internalList: (projectId, year) => {
    return get(`project/${projectId}/resource?productCategoryType=HOUR&serviceType=INTERNAL&year=${year}`);
  },
  externalList: (projectId, year) => {
    return get(`project/${projectId}/resource?productCategoryType=HOUR&serviceType=EXTERNAL&year=${year}`);
  },
  servicesHourListDetails: (projectId, projectTaskId, year) => {
    return get(
      `project/${projectId}/resource/project-task/${projectTaskId}/suppliers/${year}?productCategoryType=HOUR`
    );
  },
  servicesPercentListDetail: (projectId, projectTaskId, year) => {
    return get(
      `project/${projectId}/resource/project-task/${projectTaskId}/suppliers/${year}?productCategoryType=PERCENT`
    );
  },
  servicesHourList: (projectId, year) => {
    return get(`project/${projectId}/resource/project-task/${year}?productCategoryType=HOUR`);
  },
  servicesPercentList: (projectId, year) => {
    return get(`project/${projectId}/resource/project-task/${year}?productCategoryType=PERCENT`);
  },
};

export default Resource;
